export const shumaStatusTypeIds = {
  IN_PROGRESS: 1,
  PENDING_ADMIN_REVIEW: 2,
  REJECTED_BY_ADMIN: 3,
  APPROVED_BY_ADMIN: 4,
  COMPLETED: 5,
  PENDING_REVIEW: 6,
  PENDING_SIGNATURE: 7,
  COMPLETED_MANUALLY: 8,
  FROZEN: 9,
};